/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import tables_IconURL from './tables.png';
import tables_InsetIconURL from './tables.svg';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Tables"
        description="name for the Tables extension"
        id="extension.tables.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="Make and use tables with rows and columns"
        description="description for the Tables extension"
        id="extension.tables.description"
    />
  ),
	iconURL: tables_IconURL,
	insetIconURL: tables_InsetIconURL,
	tags: ["Made by PRG"],
	featured: true,
	extensionId: 'tables',
}